<template>

  <b-card>

    <FormAddLab400
      v-if="canAddLabs"
      :examenes400="examenes400"
    />

    <CardEnvioLabs400
      :examenes400="examenes400"
    />


    <EditarEnvioLab400
      :examenes400="examenes400"
    />

  </b-card>
</template>

<script>
import FormAddLab400           from './FormAddLab400.vue';
import CardEnvioLabs400        from './CardEnvioLabs400.vue';
import EditarEnvioLab400       from './EditarEnvioLab400.vue';
import { labAs400Service }     from '../../services';
import { laboratoriosService } from '@/views/laboratorio/services/laboratoriosService';

export default {

  name: "RegistroEnvioLabs400",

  props:{

    tokenAtencion:{
      type: String,
      default: null
    },

    maxEnvios: {
      type: Number,
      default: null 
    },

    onlyView: {
      type: Boolean,
      default: false
    },

    saveInState: {
      type: Function,
      default: null
    },

    alertNoRegistros: {
      type: Boolean,
      default: false
    },

  },

  components:{
    FormAddLab400,
    CardEnvioLabs400,
    EditarEnvioLab400
  },


  created(){
    this.loadData();
  },

  data(){
    return{
      examenes400:[]
    }
  },



  methods:{

    async loadData(){

      if(this.tokenAtencion){
        const responseLabs = await labAs400Service.getByAtencion(this.tokenAtencion);
        if (!responseLabs) return;

        this.examenes400 = await Promise.all(
        
          responseLabs.map( async (lab) => {

            const laboratorios = await laboratoriosService.searchMultiplesLaboratoriosById(lab.idslaboratorios.split(','));

            const examenesMapped = laboratorios.map( examenes => {
              return{
                ...examenes,
                value: examenes.id,
                text: `(${examenes.codigo}) ${examenes.descripcion}`
              }
            })

            return {
              accion           : 'registrado',
              codigoOrden      : lab.numeroOrden,
              laboratorios     : examenesMapped,

              justificacion    : lab.justificacion,
              idRegistro       : lab.id,
              estadoLaboratorio: lab.estadoLab400,
              estudioLab       : lab.estudiolab?.id
            }
          })
        );

      }
    }
  },



  computed:{
    
    canAddLabs(){
      if (this.onlyView) return false;
      return this.maxEnvios === null || this.examenes400.length < this.maxEnvios;
    }
  },


  watch:{
    examenes400:{
      deep:true,
      handler(newValue){
        if(!this.saveInState) return;
        this.saveInState(newValue);
      }
    },


    tokenAtencion(newValue) {
      if(newValue) this.loadData();
    }
  }
}
</script>
